import React, { useState } from "react";
import { useNotaire } from "../../context/NotaireContext";
import Select from "react-select";
import { Field, Label } from "../../components/catalyst/fieldset";
import { toast } from "react-toastify";

// 🔤 Langues connues + drapeaux
const BASE_LANGUES_OPTIONS = [
  { value: "Français", label: "🇫🇷 Français" },
  { value: "Anglais", label: "🇬🇧 Anglais" },
  { value: "Espagnol", label: "🇪🇸 Espagnol" },
  { value: "Allemand", label: "🇩🇪 Allemand" },
  { value: "Italien", label: "🇮🇹 Italien" },
  { value: "Arabe", label: "🇸🇦 Arabe" },
  { value: "Chinois", label: "🇨🇳 Chinois" },
  { value: "Portugais", label: "🇵🇹 Portugais" },
  { value: "Japonais", label: "🇯🇵 Japonais" },
  { value: "Turc", label: "🇹🇷 Turc" },
  { value: "Russe", label: "🇷🇺 Russe" },
  { value: "Tamoul", label: "🇮🇳 Tamoul" }
];

// 🔁 Convertit une langue (string) en { value, label }, avec fallback sans drapeau
const getLangueOption = (langue) => {
  const found = BASE_LANGUES_OPTIONS.find((opt) => opt.value === langue);
  return found || { value: langue, label: langue };
};

function PanelLanguesParlees() {
  const context = useNotaire();
  const [langues, setLangues] = useState(
    (context.infoNotaire.langues_parlees || []).map(getLangueOption)
  );
  const [loading, setLoading] = useState(false);

  const handleLanguesChange = (selected) => {
    setLangues(selected || []);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const languesToSave = langues.map((opt) => opt.value);

    try {
      const res = await fetch(
        `https://api.airtable.com/v0/appD48APNaGA4GN0B/info-notaire/${context.infoNotaire.id}`,
        {
          method: "PATCH",
          headers: {
            Authorization: "Bearer patfRIUbOM9xqwLV2.dfbc9a305f2124aff75634c819a8335ecd984b1d19e98f67f14013378ed6bb02",
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ fields: { langues_parlees: languesToSave } }),
        }
      );

      if (res.ok) {
        toast.success("Langues mises à jour !");
      } else {
        const errText = await res.text();
        console.error("Erreur Airtable :", errText);
        toast.error("Erreur lors de la mise à jour.");
      }
    } catch (err) {
      console.error("Erreur réseau :", err);
      toast.error("Erreur réseau");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit} className="bg-white p-6 rounded shadow mt-8">
      <Field>
        <Label>Langues parlées</Label>
        <Select
          isMulti
          options={BASE_LANGUES_OPTIONS}
          value={langues}
          onChange={handleLanguesChange}
          placeholder="Sélectionnez les langues parlées"
        />
      </Field>

      <button type="submit" className="btn-primary mt-4" disabled={loading}>
        {loading ? "Mise à jour..." : "Modifier les langues parlées"}
      </button>
    </form>
  );
}

export default PanelLanguesParlees;